var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m24.7267 26.2857h-3.7402-3.1173v-7.4857h2.4942l-4.3636-5.4857-4.3636 5.4857h2.4927v7.4857h-3.1165-3.74023c-2.75408 0-4.98701-2.4563-4.98701-5.4858 0-2.5618 1.60457-4.6971 3.7627-5.2992.23937-5.4473 4.31754-9.78647 9.32824-9.78647 4.9546 0 8.999 4.24183 9.3194 9.60407 2.7965-.0219 5.0182 2.4686 5.0182 5.4816 0 3.0295-2.2329 5.4858-4.987 5.4858z",
    fill: "#4c5664",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.2c8bfbc118a7a5f7b61b10540a4a8881.svg";
export { ForwardRef as ReactComponent };